// extracted by mini-css-extract-plugin
export default {"container":"ScooterPreview_container__Qx0i9","image":"ScooterPreview_image__6511h","inline":"ScooterPreview_inline__i0cvi"};